import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemExportRoute: InvariantJiraRoute = {
	name: 'global-settings-system-export',
	path: '/secure/admin/CloudExport.jspa',
};
